import React from 'react';
import { Checkbox } from '../Checkbox/Checkbox';
import './CheckboxGroup.scss';

interface CheckboxOption {
  value: string;
  label: string;
}

interface CheckboxGroupProps {
  id?: string;
  name?: string;
  label?: string;
  options: CheckboxOption[];
  value: string[];
  onChange: (values: string[]) => void;
  error?: string;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  id,
  name,
  label,
  options,
  value,
  onChange,
  error,
}) => {
  const handleChange = (optionValue: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    const newValue = isChecked ? [...value, optionValue] : value.filter((v) => v !== optionValue);
    onChange(newValue);
  };

  return (
    <div className="checkbox-group">
      {label && <label className="checkbox-group-label">{label}</label>}
      <div className="checkbox-group-options">
        {options.map((option) => (
          <label key={option.value} className="checkbox-group-option">
            <Checkbox
              checked={value.includes(option.value)}
              onChange={handleChange(option.value)}
            />
            <span className="checkbox-group-option-label">{option.label}</span>
          </label>
        ))}
      </div>
      {error && <div className="checkbox-group-error">{error}</div>}
    </div>
  );
};
